import router from "~/common/router";
import RegistrationEmailsNew from "~/pages/registration_emails/new";

router("users/registration_emails", ["new"], () => {
  document.addEventListener("DOMContentLoaded", () => {
    RegistrationEmailsNew.start();
  });
});
